import { useContext } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { setCurrentFilter } from 'shared/redux/creation-filters'
import { resetCreationTool, setCreationUploadInfo, updateCreationTool } from 'shared/redux/creation-tool'
import filePortalUtils from 'shared/util/file-portal-utils'
import { isVimeoUrl, isYoutubeUrl } from 'shared/util/gif-maker-util'
import urlUtils from 'shared/util/url-utils'
import { setSlideshow } from '../../gif-maker/redux/slideshow'
import { VIDEO_MIME_TYPES } from '../constants'
import { CreationToolsContext } from '../manager'
import { GIF_MAKER } from '../routes'
import CreationToolOutputType from '../types/output-type'
import CreationToolStep from '../types/steps'

type Props = {
    resetCreationTool: () => void
    setCurrentFilter: (filter: any) => void
    updateCreationTool: (data: any) => void
    setSlideshow: (files: any) => void
}

const CreationToolsLegacyFile = ({ resetCreationTool, setCurrentFilter, updateCreationTool, setSlideshow }: Props) => {
    const { source, steps, outputType } = useContext(CreationToolsContext)
    const { push } = useHistory()

    useAsyncEffect(async () => {
        resetCreationTool()
        setCurrentFilter({})
        if (source && steps.length && outputType !== CreationToolOutputType.Sticker) {
            let data = {}
            let isVideo = false

            if (typeof source === 'string') {
                const isYoutube = isYoutubeUrl(source)
                const isVimeo = isVimeoUrl(source)
                const mediaType = urlUtils.mediaType(source)
                isVideo = isYoutube || isVimeo || mediaType === 'video'
                data = {
                    file: source,
                    preview: source,
                    fileType: isYoutube ? 'youtube' : isVimeo ? 'vimeo' : mediaType,
                    type: 'url',
                }
            } else {
                isVideo = VIDEO_MIME_TYPES.indexOf(source.type) > -1
                data = {
                    file: source,
                    fileType: isVideo ? 'video' : 'image',
                    type: 'file',
                }
            }

            const previewData = await filePortalUtils.generatePreview(data)
            const file = { ...data, ...previewData }
            setSlideshow([file])
            updateCreationTool({ file })

            // allow stickers to go through the new routing
            // (this file will be deleted when everthing is ported)
            push(`${GIF_MAKER}${CreationToolStep.route(steps[0])}`)
        }
    }, [source, steps])

    return null
}

export default connect(null, {
    updateCreationTool,
    setCreationUploadInfo,
    resetCreationTool,
    setCurrentFilter,
    setSlideshow,
})(CreationToolsLegacyFile)
